<template>
  <ReadOnlyItem v-if="disabled" :gray="gray" label="Model" :value="selectedModel?.meterModelNumber" />
  <InlineTypeaheadModal
    v-else
    :clearable="false"
    clear-search-on-dismiss
    :gray="gray"
    :state="state"
    :errors="errors"
    v-model="selectedModel"
    title="Model"
    label-key="meterModelNumber"
    :get-options="getOptions"
    :compare-with="compareWith"
  ></InlineTypeaheadModal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { UtilityFamily } from '@ncss/models/dist/v3';
import { FormControlError, FormControlState } from '@/composables/use-form-control';
import InlineTypeaheadModal from '../typeahead/InlineTypeaheadModal.vue';
import { useMeterModels } from '@/composables/use-meter-models';
import { MobileMeterType } from 'common';
import ReadOnlyItem from '../ReadOnlyItem.vue';

const props = defineProps<{
  utilityFamily: UtilityFamily;
  manufacturerId?: number;
  gray?: boolean;
  state?: FormControlState;
  errors?: FormControlError[];
  disabled?: boolean;
}>();
const emit = defineEmits<{
  (e: 'modelSelected', m?: MobileMeterType): void;
}>();
const { search, findById, all } = useMeterModels(
  () => props.utilityFamily,
  () => props.manufacturerId
);
const vModel = defineModel({ type: Number });
const selectedModel = ref<MobileMeterType>();

function getOptions(text?: string): Promise<MobileMeterType[]> {
  return search(text);
}

function compareWith(a: any, b: any) {
  return a?.meterTypeId === b?.meterTypeId;
}

watch(selectedModel, (val) => {
  if (val?.meterTypeId !== vModel.value) {
    emit('modelSelected', val);
    vModel.value = val?.meterTypeId;
  }
});

watch(
  vModel,
  async (val) => {
    if (val !== selectedModel.value?.meterTypeId) {
      selectedModel.value = val ? await findById(val) : undefined;
    }
  },
  { immediate: true }
);

watch(all, (options) => {
  if (!options.length) {
    selectedModel.value = undefined;
  }
});

defineExpose({
  selectedModel,
});
</script>

<style scoped></style>
